// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken } from "firebase/messaging";
// import { savedFcmToken } from "../helper/fcmTokenSave";

// const firebaseConfig = {
//   apiKey: "AIzaSyAeyMy48Ny3RDKUyMkq7_fnZETdfCwIQ7k",
//   authDomain: "gsm-treding-institute.firebaseapp.com",
//   projectId: "gsm-treding-institute",
//   storageBucket: "gsm-treding-institute.firebasestorage.app",
//   messagingSenderId: "845607622484",
//   appId: "1:845607622484:web:23670f17d9289531a05ac1",
//   measurementId: "G-85V0BG32Q6",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// export const messaging = getMessaging(app);

// export const generateToken = async () => {
//   const permission = await Notification.requestPermission();
//   console.log(permission);
//   let token;
//   if (permission == "granted") {
//     token = await getToken(messaging, {
//       vapidKey:
//         "BOraLcKrtehoxeaKk7uJgwWS9esTCR3ldSpB4kX3AYXRa7-kMN3rDSqr6duUgri39KTpo90lUlFgAeFkTkfgRm0",
//     });
//     console.log(token);
//     savedFcmToken(token);
//     return token;
//   }
//   return token;
// };


// // // Register the service worker manually
// navigator.serviceWorker
//   .register("/firebase-messaging-sw.js") // ✅ Correct path for Vite
//   .then((registration) => {
//     console.log("Service Worker Registered ✅", registration);
//   })
//   .catch((error) => {
//     console.error("❌ Service Worker Registration Failed:", error);
//   });
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { savedFcmToken } from "../helper/fcmTokenSave";

const firebaseConfig = {
    apiKey: "AIzaSyAeyMy48Ny3RDKUyMkq7_fnZETdfCwIQ7k",
    authDomain: "gsm-treding-institute.firebaseapp.com",
    projectId: "gsm-treding-institute",
    storageBucket: "gsm-treding-institute.firebasestorage.app",
    messagingSenderId: "845607622484",
    appId: "1:845607622484:web:23670f17d9289531a05ac1",
    measurementId: "G-85V0BG32Q6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            console.warn("❌ Notifications permission not granted");
            return null;
        }

        // Ensure Service Worker is ready
        const registration = await navigator.serviceWorker.ready;

        // Now, generate the token using the registered Service Worker
        const token = await getToken(messaging, {
            vapidKey: "BOraLcKrtehoxeaKk7uJgwWS9esTCR3ldSpB4kX3AYXRa7-kMN3rDSqr6duUgri39KTpo90lUlFgAeFkTkfgRm0",
            serviceWorkerRegistration: registration, // 🔥 Use the registered Service Worker
        });

        if (token) {
            console.log("✅ FCM Token:", token);
            savedFcmToken(token);
        } else {
            console.warn("❌ No FCM token received");
        }

        return token;
    } catch (error) {
        console.error("❌ Error fetching FCM token:", error);
        return null;
    }
};
